// extracted by mini-css-extract-plugin
export default {"font":"Data_font__RM6qA"};